

/// <reference path="StockNoteProductLine.ts" />

// Generated class CustomOutputNoteLine_ManagedObject

class CustomOutputNoteLine_ManagedObject extends StockNoteProductLine
{
}
